module.exports = __webpack_public_path__ + "static/media/quotes-step-icon-white.8cdf3f79.svg";